import TableCSVExporter from '@/plugins/tabletocsv'
var CryptoJS = require("crypto-js");
import {
    mapMutations
  } from 'vuex'
export const API_MIXINS = {
    data () {
        return {
         
        }
      },
    methods: {
        ...mapMutations([
            'setMonthDailySales',
            'setCredits',
            'setAlert',
            'setAlertColor', 
            'setAlertText', 
            'setLoggedIn', 
            'setSettings',
            'setSuppliers',
            'setTrucks',
            'setDrivers',
            'setCategories',
            'setProducts',
            'setCustomertypes',
            'setCustomers',
            'setUsers',
            'setOverlayLoading',
            'setOverlayLoadingText',
            'setAllowedMenus',
            'setAvailables'
        ]),
        GET_AVAILABLES() {
            this.$http.post("product/available").then(response => {
                response.data.items !=null?this.setAvailables(response.data.items):this.setAvailables([])
               }).catch(e => {
                console.log(e.data)
            })
        },
        GET_USERS() {
            this.$http.post("user/list").then(response => {
                response.data.data !=null?this.setUsers(response.data.data):this.setUsers([])
               }).catch(e => {
                console.log(e.data)
            })
        },
        GET_CUSTOMERS(status) {
            this.$http.post("customer/list", {status:status}).then(response => {
                response.data.items !=null?this.setCustomers(response.data.items):this.setCustomers([])
               }).catch(e => {
                console.log(e.data)
            })
        },
        GET_CUSTOMER_TYPES() {
            this.$http.post("customer/list_type", {}).then(response => {
                response.data.items !=null?this.setCustomertypes(response.data.items):this.setCustomertypes([])
               }).catch(e => {
                console.log(e.data)
            })
        },
        GET_PRODUCTS() {
            this.$http.post("product/list", {}).then(response => {
                response.data.items !=null?this.setProducts(response.data.items):this.setProducts([])
               
               }).catch(e => {
                console.log(e.data)
            })
        },
        GET_CATEGORIES() {
            this.$http.post("category/list", {}).then(response => {
                response.data.items !=null?this.setCategories(response.data.items):this.setCategories([])
               }).catch(e => {
                console.log(e.data)
            })
        },
        GET_SETTINGS() {
            this.$http.post("setting/list", {}).then(response => {
                response.data.items !=null?this.setSettings(response.data.items):this.setSettings([])
               }).catch(e => {
                console.log(e.data)
            })
        },
        GET_SUPPLIERS() {
            this.$http.post("supplier/list", {}).then(response => {
                response.data.items !=null?this.setSuppliers(response.data.items):this.setSuppliers([])
               }).catch(e => {
                console.log(e.data)
            })
        },
        GET_DRIVERS() {
            this.$http.post("driver/list", {}).then(response => {
                response.data.items !=null?this.setDrivers(response.data.items):this.setDrivers([])
               }).catch(e => {
                console.log(e.data)
            })
        },
        GET_TRUCKS() {
            this.$http.post("truck/list", {}).then(response => {
                response.data.items !=null?this.setTrucks(response.data.items):this.setTrucks([])
               }).catch(e => {
                console.log(e.data)
            })
        },
        GET_RESPONSE(response){
            response.data.status?this.VA_ALERT('success', response.data.message):this.VA_ALERT('error', response.data.message)
        },
        GET_SALESMEN() {
            if(this.$store.state.users == undefined || this.$store.state.users == null) {
              return []
            }
            var arr = this.$store.state.users.reduce((res, item)=>{
                if(item.role=='salesman') {
                  item.label = item.assign_code + '- ' + item.fullname
                  res.push(item)
                }
                return res
            },[])
            return arr
          },
        VA_ALERT(color, message) {
                this.setAlertText(message)
                this.setAlertColor(color)
                this.setAlert(true)
        },
        STATUS_TEXT(status) {
            switch(status){
                    case 'on-process':
                        return 'text-warning va-status'
                    case 'posted':
                        return 'text-accent va-status'
                    case 'approved':
                        return 'text-secondary va-status'
                    case 'complete':
                        return 'text-success va-status'
                    case 'outbound':
                        return 'text-info va-status'
                    case 'inbound':
                        return 'text-success va-status'
                    case 'paid':
                        return 'text-success va-status'
                    case 'delivered':
                        return 'text-success va-status'
                    case 'For Verification':
                        return 'text-info va-status'
                    case 'Verified':
                        return 'text-success va-status'
                    case 'issued':
                        return 'text-info va-status'
                    case 'Borrowed':
                        return 'text-warning va-status'
                    case 'Returned':
                        return 'text-success va-status'
                    case 'redeemed':
                        return 'text-success va-status'
                    case 'available':
                        return 'text-info va-status'
                    default:
                        return 'text-default va-status'

            }
            
        },
        APPLOADER(state, text=''){
            state?this.setOverlayLoadingText(text):this.setOverlayLoadingText('')
            this.setOverlayLoading(state)

        },
        DownloadToCsv (eleID, filename) {
            const dataTable = document.getElementById(eleID)
            const exporter = new TableCSVExporter(dataTable)
            const csvOutput = exporter.convertToCSV()
            const csvBlob = new Blob([csvOutput], { type: 'text/csv' })
            const blobUrl = URL.createObjectURL(csvBlob)
            const anchorElement = document.createElement('a')
      
            anchorElement.href = blobUrl
            anchorElement.download =  filename+ '.csv'
            anchorElement.click()
      
            setTimeout(() => {
              URL.revokeObjectURL(blobUrl)
            }, 500)
          },
          NETWORK_ERROR(e){
            if(e.response == undefined) {
                    this.VA_ALERT('Error', "No Internet Connection!")
            } else {
                this.VA_ALERT('error', "No avaialable this time!")
            }
          },
          PING() {
            this.$http.post("ping", {}, {timeout: 1000}).then(() => {
               }).catch(e => {
                this.NETWORK_ERROR(e)
            })
        },
        GEN_HASH_VALUE(email) {
                var ciphertext = CryptoJS.AES.encrypt(this.$moment().format("YYYY-MM-DD") +'::'+ email, 'secret key 123').toString();
                return ciphertext
        },
        GET_HASH_VALUE(ciphertext) {
                    var current = this.$moment(current).format("YYYY-MM-DD")
                    var bytes  = CryptoJS.AES.decrypt(ciphertext, 'secret key 123');
                    var originalDate= bytes.toString(CryptoJS.enc.Utf8);
                    if(originalDate == current) {
                        return true
                    }
                    return false
      },
      APP_PAGES() {
        var paths = this.$router.options.routes.reduce((res,item)=> {
            if(item.path != '/login' && item.path != '/forgot-password' && item.path!='/no-permission') {
                if(item.name != undefined) {
                    res.push({name:item.name})
                }
            }
            return res
        },[])
        return paths
      },
      SET_MENUS(){
        var current = this.$store.state.menus 
        const arrMenus = Object.entries(this.$store.state.menus)
        var allowed_menus = sessionStorage.allowed_pages != 'null'?JSON.parse(sessionStorage.allowed_pages):[]
        for (const [groupname, menus] of arrMenus) {
            current[groupname] = []
            for(var i=0;i<menus.length;i++){
                if(allowed_menus.indexOf(menus[i].title) != -1) {
                    current[groupname].push(menus[i])
                }
            }
        }
        this.setAllowedMenus(current)
      },
    } ///eof methods
}